import { useCallback } from "react";
import { Apis } from "../../lib/Apis";

export function useTranslations() {
  const getModules = useCallback(async () => {
    const response = await Apis.getTranslationModules();
    return response?.data?.data?.modules || [];
  }, []);

  const getStats = useCallback(async () => {
    const response = await Apis.getTranslationStats();
    return response?.data?.data || {};
  }, []);

  const getJobs = useCallback(async (params = {}) => {
    const response = await Apis.getTranslationJobs(params);
    return response?.data?.data || { items: [], pagination: {} };
  }, []);

  const getJob = useCallback(async (id) => {
    const response = await Apis.getTranslationJob(id);
    return response?.data?.data?.job || null;
  }, []);

  const generate = useCallback(async (payload) => {
    const response = await Apis.generateTranslations(payload);
    return response?.data?.data?.job || null;
  }, []);

  const retryJob = useCallback(async (id) => {
    const response = await Apis.retryTranslationJob(id);
    return response?.data?.data?.job || null;
  }, []);

  const stopJob = useCallback(async (id) => {
    const response = await Apis.stopTranslationJob(id);
    return response?.data?.data?.job || null;
  }, []);

  const deleteJob = useCallback(async (id) => {
    const response = await Apis.deleteTranslationJob(id);
    return response?.data?.data || null;
  }, []);

  return {
    getModules,
    getStats,
    getJobs,
    getJob,
    generate,
    retryJob,
    stopJob,
    deleteJob,
  };
}
